import { Box, Typography } from 'shared/ui'
import { AgentSwitchField } from 'pages/chatbot/ui/AgentSwitchField/AgentSwitchField'

export const SmartMeeting = ({
  active,
  onChange,
}: {
  active: boolean
  onChange: (value: boolean) => void
}) => {
  return (
    <AgentSwitchField
      title={'Smart Meeting'}
      active={active}
      onChange={onChange}
      isBeta
      questionInfoTooltip={
        <Box display={'flex'} flexDirection={'column'} gap={'2px'}>
          <Typography
            variant={'body-md-regular'}
            ariaLabel={'title'}
            color={'var(--content-primary-primary-inverted)'}
          >
            Customers can manage appointments by text.
          </Typography>
          <Typography
            variant={'body-sm-regular'}
            ariaLabel={'title'}
            color={'var(--content-primary-tertiary-inverted)'}
          >
            The AI automatically handles reminders, cancellations <br /> (reply DROP), reschedules
            (reply RESCHEDULE), and <br /> follows up on missed appointments.
          </Typography>
        </Box>
      }
    />
  )
}
